<template>
    <div id="app" v-show="appShow">
        <router-view />
    </div>
</template>

<script>
import NoSleep from 'nosleep.js'
export default {
    name: 'App',
    data() {
        return {
            appShow: true,
        }
    },
    created() {
        import('./common/events')
    },
    mounted() {
        this.noSleep()
    },
    methods: {
        noSleep() {
            var noSleep = new NoSleep()
            document.addEventListener(
                'click',
                function enableNoSleep() {
                    document.removeEventListener('click', enableNoSleep, false)
                    noSleep.enable()
                },
                false
            )
        },
    },
}
</script>

<style lang='less'>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    background-color: transparent;
    width: 100%;
    height: 100%;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue